// extracted by extract-css-chunks-webpack-plugin
module.exports = {"circularChart":"oMz2AE","circleBg":"_2M20F7","circle":"TjRzms"};